// @ts-nocheck
/* eslint-disable */
export const synthesizeIcon = {
  data: `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.16663 15V5H10.8333V15H9.16663Z" fill="currentColor"/><path d="M5.28527 10.8335H1.66663V9.16687H5.28635L3.17293 7.05352L4.35152 5.875L8.47627 9.99978L4.35127 14.1245L3.17277 12.946L5.28527 10.8335Z" fill="currentColor"/><path d="M14.858 9.16598L18.3334 9.16598L18.3334 10.8326L14.8569 10.8326L16.9703 12.946L15.7917 14.1245L11.667 9.99973L15.792 5.87498L16.9705 7.05348L14.858 9.16598Z" fill="currentColor"/></svg>`,
  name: 'synthesize' as const,
};
